import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login-btn',
  template: `<button
    class="btn btn-primary"
    title="{{ 'pages.login' | translate }}"
    (click)="redirectToLogin()"
  >
    {{ 'pages.login' | translate }}
  </button>`,
})
export class LoginButtonComponent {
  constructor() {}

  redirectToLogin() {
    if(window.location.host.includes('stg')){
      window.open(`https://stgweb.umang.gov.in/web_new/login`, '_self');
    }
    window.open(`${environment.deployUrl}/web_new/login`, '_self');
  }
}
